import { render } from "./PhoneCode.vue?vue&type=template&id=1bf79472"
import script from "./PhoneCode.vue?vue&type=script&lang=js"
export * from "./PhoneCode.vue?vue&type=script&lang=js"

import "../PhoneCodePicker/phone.css?vue&type=style&index=0&lang=css"

import exportComponent from "D:\\MY PROJECTS\\VUE_3\\EXCEL_LIBRARY\\excel-library-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__